import React, { Component } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import Cookies from "universal-cookie";
import moment from "moment";
import CurrencyInput from "react-currency-input-field";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { SaveOutlined, InboxOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, DatePicker, Divider, Form, Input, Modal, Row, Select, Switch, Tabs, Upload } from "antd";
import { CreateOrderStates } from "./types/CreateOrderTypes";
import { dealerApiService } from "../../services/otodis/DealerApiService";
import { catalogAreaServices } from "../../services/catalog/CatalogAreaService";
import { orderService } from "../../services/otodisApi/OrderService";
import SearchStockByStockUnit from "../../components/stock/SearchStockByStockUnit";
import SearchStockByEngineNumber from "../../components/stock/SearchStockByEngineNumber";
import SearchStockByVariant from "../../components/stock/SearchStockByVariant";
import AreaProvinceSelect from "../../components/area/AreaProvinceSelect";
import AreaCitySelect from "../../components/area/AreaCitySelect";
import AreaDistrictSelect from "../../components/area/AreaDistrictSelect";
import LeasingSelect from "../../components/multifinance/Leasing";
import ServicebureauSelect from "../../components/servicebureau/ServicebureauSelect";
import AreaSubdistrictSelect from "../../components/area/AreaSubdistrictSelect";
import OtodisDeliveryDriverSelect from "../../components/otodis/OtodisDeliveryDriverSelect";
import OtodisDeliveryVehicleSelect from "../../components/otodis/OtodisDeliveryVehicleSelect";
import { baseUrlCdnUpload } from "../../config/api/apiConfig";
import { organizationApiService } from "../../services/robofin/OrganizationApiService";
import DepositComponent from "../../components/order/CheckDeposit";
import { taxOtodisService } from "../../services/otodisApi/TaxOtodisService";

export interface CreateOrderProps {}

const { TabPane } = Tabs;

class CreateOrder extends Component<CreateOrderProps & any, CreateOrderStates> {
  private readonly initState!: CreateOrderStates;
  private token = new Cookies().get("_t");

  constructor(props: (CreateOrderProps & any) | any) {
    super(props);

    this.initState = {
      submitting: false,
      formSearchStock: true,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      searchStockUnitCode: "",
      chosenStock: [],
      cityGroup: "",
      paymentMethod: false,
      orderDelivery: true,
      bbn: false,
      orderDate: moment(new Date(), "YYYY-MM-DD"),

      customerType: false,
      customerBusinessEntity: null,
      customerName: "",
      customerDocName: "",
      customerId: "",
      customerPhone: "",
      customerProvinceCode: "",
      customerProvinceName: "",
      customerCityCode: "",
      customerCityName: "",
      customerDistrictCode: "",
      customerDistrictName: "",
      customerSubdistrictCode: "",
      customerSubdistrictName: "",
      customerPostalCode: "",
      customerAddress: "",

      marketingName: "",
      marketingCode: "",
      amhOrderNumber: "",

      incentiveOut: 0,
      transferOfTitleCostEstimation: 0,
      noticeCost: 0,
      processCost: 0,
      vehicleSalesPrice: 0,
      orderDownPayment: 0,
      orderDiscount: 0,

      inputLeasingPo: false,
      leasingCode: "",
      leasingName: "",
      leasingDocNumber: "",
      leasingRepayment: 0,
      leasingSubsidies: 0,
      orderTenor: 0,
      orderInstallment: 0,
      orderImagePo: "https://storage.googleapis.com/amren_id/signature/white_blank.png",

      ddmsIdOrder: "",
      ddmsInvoiceNumber: "",
      ddmsReceiverName: "",

      taxProcess: true,
      taxActive: true,
      taxUrl: "",
      taxPercetage: 11,
      taxInvoiceNumber: "",
      taxInvoiceDate: "",
      taxNpwpNumber: "",
      taxNpwpName: "",
      taxNpwpAddress: "",
      taxReceiverNumber: "",
      taxReceiverName: "",
      taxReceiverAddress: "",
      totalDppNon: 0,
      totalPpn: 0,
      totalPph22: 0,
      estTotalDppNon: 0,
      estTotalPpn: 0,

      driverCode: "",
      driverName: "",
      deliveryDate: moment().clone().format("YYYY-MM-DD"),
      deliveryNumber: "",
      deliveryLicensePlate: "",
      handoverDate: moment().clone().format("YYYY-MM-DD"),
      receiverNik: "",
      receiverName: "",
      receiverPhone: "",
      receiverSignature: "",
      receiverSignatureThumb: "",
      handoverProof: "",
      handoverProofThumb: "",

      showUploadList: true,
      disableField: false,
      vehicleInvoicePrice: 0,
      vehicleDeposit: 0,
      depositData: [],
      companyCode: "",
      serviceBureauName: "",
      serviceBureauCode: "",
      BbnInvoiceNumber: "",
      DocumentLicensePlate: "",
      DocumentBpkb: "",
      DocumentStnk: "",
      DocumentNotice: "",
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    this.setState({
      dealerCode: data.value,
    });
  };

  onStockChosen = async (data: any) => {
    await this.promisedSetState({
      formSearchStock: false,
      chosenStock: data,
      leasingRepayment: data?.vehicle_sales_price - this.state.orderDownPayment,
    });

    this.fetchCopanVariantData();
  };

  // onPaymentMethodChange = (data: any) => {
  //   this.setState({
  //     paymentMethod: data,
  //     inputLeasingPo: data,
  //   });
  // };

  onOrderDelivery = (data: any) => {
    this.setState({
      orderDelivery: data,
    });
  };

  onCustomerTypeChange = (data: any) => {
    const disabled = data ? true : false;

    this.setState({
      customerType: data,
      disableField: disabled,
    });
  };

  onOrderDateChange = (data: any) => {
    this.setState({
      orderDate: data,
    });
  };

  onStringFieldChange = <
    T extends keyof Pick<
      any,
      | "taxUrl"
      | "taxPercetage"
      | "taxProcess"
      | "taxActive"
      | "ddmsInvoiceNumber"
      | "ddmsReceiverName"
      | "ddmsIdOrder"
      | "customerName"
      | "customerBusinessEntity"
      | "customerId"
      | "customerDocName"
      | "customerPhone"
      | "customerAddress"
      | "customerPostalCode"
      | "marketingName"
      | "marketingCode"
      | "amhOrderNumber"
      | "vehicleSalesPrice"
      | "orderDownPayment"
      | "orderDiscount"
      | "leasingDocNumber"
      | "leasingSubsidies"
      | "orderTenor"
      | "orderInstallment"
      | "transferOfTitleCostEstimation"
      | "noticeCost"
      | "processCost"
      | "deliveryNumber"
      | "deliveryDate"
      | "handoverDate"
      | "receiverNik"
      | "receiverName"
      | "receiverPhone"
      | "receiverSignature"
      | "handoverProof"
      | "vehicleInvoicePrice"
      | "paymentMethod"
      | "bbn"
      | "BbnInvoiceNumber"
      | "DocumentLicensePlate"
      | "DocumentBpkb"
      | "DocumentStnk"
      | "DocumentNotice"
      | "taxInvoiceNumber"
      | "taxInvoiceDate"
      | "taxNpwpNumber"
      | "taxNpwpName"
      | "taxNpwpAddress"
      | "taxReceiverNumber"
      | "taxReceiverName"
      | "taxReceiverAddress"
      | "totalDppNon"
      | "totalPpn"
      | "totalPph22"
    >
  >(
    target: T,
    value: any
  ) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "taxUrl":
        currentState.taxUrl = value;
        break;
      case "taxPercetage":
        currentState.taxPercetage = value;
        break;
      case "taxProcess":
        currentState.taxProcess = value;
        currentState.taxUrl = "";
        currentState.taxInvoiceNumber = "";
        currentState.taxInvoiceDate = "";
        currentState.taxNpwpNumber = "";
        currentState.taxNpwpName = "";
        currentState.taxNpwpAddress = "";
        currentState.taxReceiverNumber = "";
        currentState.taxReceiverName = "";
        currentState.taxReceiverAddress = "";
        currentState.totalDppNon = 0;
        currentState.totalPpn = 0;
        currentState.totalPph22 = 0;
        break;
      case "taxActive":
        currentState.taxActive = value;
        break;
      case "ddmsInvoiceNumber":
        currentState.ddmsInvoiceNumber = value;
        break;
      case "ddmsReceiverName":
        currentState.ddmsReceiverName = value;
        break;
      case "ddmsIdOrder":
        currentState.ddmsIdOrder = value;
        break;
      case "customerName":
        currentState.customerName = value;
        break;
      case "customerId":
        currentState.customerId = value;
        break;
      case "customerDocName":
        currentState.customerDocName = value;
        break;
      case "customerBusinessEntity":
        currentState.customerBusinessEntity = value;
        break;
      case "customerPhone":
        currentState.customerPhone = value;
        break;
      case "customerAddress":
        currentState.customerAddress = value;
        break;
      case "customerPostalCode":
        currentState.customerPostalCode = value;
        break;
      case "marketingName":
        currentState.marketingName = value;
        break;
      case "marketingCode":
        currentState.marketingCode = value;
        break;
      case "amhOrderNumber":
        currentState.amhOrderNumber = value;
        break;
      case "transferOfTitleCostEstimation":
        currentState.transferOfTitleCostEstimation = value;
        break;
      case "noticeCost":
        currentState.noticeCost = value;
        currentState.transferOfTitleCostEstimation = currentState.noticeCost + currentState.processCost;
        break;
      case "processCost":
        currentState.processCost = value;
        currentState.transferOfTitleCostEstimation = currentState.noticeCost + currentState.processCost;
        break;
      case "vehicleSalesPrice":
        currentState.vehicleSalesPrice = value;
        break;
      case "orderDownPayment":
        currentState.orderDownPayment = value;
        break;
      case "orderDiscount":
        currentState.orderDiscount = value;
        break;
      case "leasingDocNumber":
        currentState.leasingDocNumber = value;
        break;
      case "leasingSubsidies":
        currentState.leasingSubsidies = value;
        break;
      case "orderTenor":
        currentState.orderTenor = value;
        break;
      case "orderInstallment":
        currentState.orderInstallment = value;
        break;
      case "deliveryDate":
        currentState.deliveryDate = value;
        break;
      case "deliveryNumber":
        currentState.deliveryNumber = value;
        break;
      case "handoverDate":
        currentState.handoverDate = value;
        break;
      case "receiverNik":
        currentState.receiverNik = value;
        break;
      case "receiverName":
        currentState.receiverName = value;
        break;
      case "receiverPhone":
        currentState.receiverPhone = value;
        break;
      case "receiverSignature":
        currentState.receiverSignature = value;
        break;
      case "handoverProof":
        currentState.handoverProof = value;
        break;
      case "vehicleInvoicePrice":
        currentState.vehicleInvoicePrice = value;
        break;
      case "paymentMethod":
        currentState.paymentMethod = value;
        currentState.inputLeasingPo = value;
        break;
      case "bbn":
        currentState.bbn = value;
        break;
      case "BbnInvoiceNumber":
        currentState.BbnInvoiceNumber = value;
        break;
      case "DocumentLicensePlate":
        currentState.DocumentLicensePlate = value;
        break;
      case "DocumentBpkb":
        currentState.DocumentBpkb = value;
        break;
      case "DocumentStnk":
        currentState.DocumentStnk = value;
        break;
      case "DocumentNotice":
        currentState.DocumentNotice = value;
        break;

      case "taxInvoiceNumber":
        currentState.taxInvoiceNumber = value;
        break;
      case "taxInvoiceDate":
        currentState.taxInvoiceDate = value;
        break;
      case "taxNpwpNumber":
        currentState.taxNpwpNumber = value;
        break;
      case "taxNpwpName":
        currentState.taxNpwpName = value;
        break;
      case "taxNpwpAddress":
        currentState.taxNpwpAddress = value;
        break;
      case "taxReceiverNumber":
        currentState.taxReceiverNumber = value;
        break;
      case "taxReceiverName":
        currentState.taxReceiverName = value;
        break;
      case "taxReceiverAddress":
        currentState.taxReceiverAddress = value;
        break;
      case "totalDppNon":
        currentState.totalDppNon = value;
        break;
      case "totalPpn":
        currentState.totalPpn = value;
        break;
      case "totalPph22":
        currentState.totalPph22 = value;
        break;
    }

    if (
      target === "vehicleSalesPrice" ||
      target === "transferOfTitleCostEstimation" ||
      target === "paymentMethod" ||
      target === "bbn" ||
      target === "orderDiscount" ||
      target === "noticeCost" ||
      target === "processCost" ||
      target === "totalPph22" ||
      target === "taxActive" ||
      target === "taxPercetage"
    ) {
      if (currentState.bbn === false) {
        if (currentState.paymentMethod === false) {
          currentState.vehicleInvoicePrice = Number(currentState.vehicleSalesPrice) - Number(currentState.transferOfTitleCostEstimation) - Number(currentState.orderDiscount);
        } else {
          currentState.vehicleInvoicePrice = Number(currentState.vehicleSalesPrice) - Number(currentState.orderDiscount);
        }
      } else {
        currentState.vehicleInvoicePrice = Number(currentState.vehicleSalesPrice) - Number(currentState.orderDiscount);
      }

      const tax_nominal = (100 + Number(currentState.taxPercetage)) / 100;

      currentState.estTotalDppNon = Math.ceil(currentState.vehicleInvoicePrice / tax_nominal);
      currentState.estTotalPpn = (currentState.estTotalDppNon * Number(currentState.taxPercetage)) / 100;
    }

    if (target === "vehicleSalesPrice" || target === "orderDownPayment" || target === "paymentMethod" || target === "bbn" || target === "noticeCost" || target === "processCost") {
      currentState.leasingRepayment = Number(currentState.vehicleInvoicePrice) - Number(currentState.orderDownPayment);
    }

    this.setState({
      ...currentState,
    });
  };

  onDepositUpdate = (value: number, data: { id: string; amount: number }[]) => {
    this.setState({
      vehicleDeposit: value,
      depositData: data,
    });
  };

  onDriverChange = (data: any) => {
    this.setState({
      driverCode: data.value,
      driverName: data.children,
    });
  };

  ondeliveryLicensePlateChange = (data: any) => {
    this.setState({
      deliveryLicensePlate: data.value,
      // assetName: data.children,
    });
  };

  onSupplierChange = (data: any) => {
    this.setState({
      serviceBureauCode: data.value,
      serviceBureauName: data.children,
    });
  };

  onAreaProvinceChange = (data: any) => {
    this.setState({
      customerProvinceCode: data.value,
      customerProvinceName: data.children,
      customerCityCode: "",
      customerCityName: "",
      customerDistrictCode: "",
      customerDistrictName: "",
      customerSubdistrictCode: "",
      customerSubdistrictName: "",
    });
  };

  onAreaCityChange = (data: any) => {
    this.setState({
      customerCityCode: data.value,
      customerCityName: data.children,
      customerDistrictCode: "",
      customerDistrictName: "",
      customerSubdistrictCode: "",
      customerSubdistrictName: "",
    });
  };

  onAreaDistrictChange = (data: any) => {
    this.setState({
      customerDistrictCode: data.value,
      customerDistrictName: data.children,
      customerSubdistrictCode: "",
      customerSubdistrictName: "",
    });
  };

  onAreaSubdistrictChange = (data: any) => {
    this.setState({
      customerSubdistrictCode: data.value,
      customerSubdistrictName: data.children,
      customerPostalCode: data.postalCode,
    });
  };

  onLeasingChange = (data: any) => {
    this.setState({
      leasingCode: data.value,
      leasingName: data.children,
    });
  };

  validateData() {
    const {
      dealerCode,
      customerId,
      customerName,
      customerPhone,
      customerSubdistrictCode,
      customerAddress,
      chosenStock,
      vehicleInvoicePrice,
      vehicleDeposit,
      deliveryNumber,
      deliveryDate,
      driverCode,
      driverName,
      deliveryLicensePlate,
      handoverDate,
      receiverNik,
      receiverName,
      receiverPhone,
      receiverSignature,
      handoverProof,
      BbnInvoiceNumber,
      DocumentLicensePlate,
      DocumentBpkb,
      DocumentStnk,
      DocumentNotice,
      paymentMethod,
      serviceBureauCode,
      bbn,
      leasingCode,
      orderTenor,
      orderInstallment,
      taxProcess,
      taxActive,
      taxUrl,
      taxPercetage,
      taxInvoiceNumber,
      taxInvoiceDate,
      taxNpwpNumber,
      taxNpwpName,
      taxNpwpAddress,
      taxReceiverNumber,
      taxReceiverName,
      taxReceiverAddress,
      totalDppNon,
      totalPpn,
      totalPph22,
    } = this.state;

    try {
      let textMsg = "";
      if (!dealerCode) {
        textMsg += "Dealer Code is required<br/>";
      }

      if (!customerId) {
        textMsg += "Customer ID is required<br/>";
      }

      if (!customerName) {
        textMsg += "Customer Name is required<br/>";
      }

      if (!customerPhone) {
        textMsg += "Customer Phone is required<br/>";
      }

      if (!customerSubdistrictCode) {
        textMsg += "Customer Subdistrict Code is required<br/>";
      }

      if (!customerAddress) {
        textMsg += "Customer Address is required<br/>";
      }

      if (!chosenStock?.stock_unit_code) {
        textMsg += "Chosen Stock Unit Code is required<br/>";
      }

      if (!vehicleInvoicePrice) {
        textMsg += "Vehicle Invoice Price is required<br/>";
      }

      if (!vehicleDeposit) {
        textMsg += "Vehicle Deposit is required<br/>";
      }

      if (!deliveryNumber) {
        textMsg += "Delivery Number is required<br/>";
      }

      if (!deliveryDate) {
        textMsg += "Delivery Date is required<br/>";
      }

      if (!driverCode) {
        textMsg += "Driver Code is required<br/>";
      }

      if (!driverName) {
        textMsg += "Driver Name is required<br/>";
      }

      if (!deliveryLicensePlate) {
        textMsg += "Delivery License Plate is required<br/>";
      }

      if (!handoverDate) {
        textMsg += "Handover Date is required<br/>";
      }

      if (!receiverNik) {
        textMsg += "Receiver NIK is required<br/>";
      }

      if (!receiverName) {
        textMsg += "Receiver Name is required<br/>";
      }

      if (!receiverPhone) {
        textMsg += "Receiver Phone is required<br/>";
      }

      if (!receiverSignature) {
        textMsg += "Receiver Signature is required<br/>";
      }

      if (!handoverProof) {
        textMsg += "Handover Proof is required<br/>";
      }

      if (bbn) {
        if (!serviceBureauCode) {
          textMsg += "Biro Jasa is required<br/>";
        }
        if (!BbnInvoiceNumber) {
          textMsg += "BBN Invoice Number is required<br/>";
        }

        if (!DocumentLicensePlate) {
          textMsg += "Document License Plate is required<br/>";
        }

        if (!DocumentBpkb) {
          textMsg += "Document BPKB is required<br/>";
        }

        if (!DocumentStnk) {
          textMsg += "Document STNK is required<br/>";
        }

        if (!DocumentNotice) {
          textMsg += "Document Notice is required<br/>";
        }
      }

      if (taxProcess === true) {
        if (taxActive === false) {
          if (totalPph22 < 1) {
            textMsg += "Total PPN tidak boleh negative is required<br/>";
          }

          const invoicePriceNonPpn = vehicleInvoicePrice - totalPpn - totalPph22;
          const checkDeposit = invoicePriceNonPpn - vehicleDeposit;

          // Validasi jika deposit kurang dari invoice dan selisihnya lebih dari 100
          if (checkDeposit > 100) {
            textMsg += `Nilai Deposit kurang ${checkDeposit} nominal<br/>`;
          }
        }

        if (!taxUrl) {
          textMsg += "URL Pajak is required<br/>";
        }

        if (
          !taxInvoiceNumber ||
          !taxInvoiceDate ||
          !taxNpwpNumber ||
          !taxNpwpName ||
          !taxNpwpAddress ||
          !taxReceiverNumber ||
          !taxReceiverName ||
          !taxReceiverAddress ||
          totalDppNon < 100 ||
          totalPpn < 100
        ) {
          textMsg += "Invalid Data Pajak, Scan URL Pajak<br/>";
        }

        if (!taxPercetage || taxPercetage < 0) {
          textMsg += "Persentase Pajak is required<br/>";
        }
      } else if (paymentMethod === false) {
        if (Number(vehicleDeposit) < Number(vehicleInvoicePrice)) {
          textMsg += "Nilai Deposit < Harga Invoice<br/>";
        }
      }

      if (paymentMethod === true) {
        if (!leasingCode) {
          textMsg += "Leasing is required<br/>";
        }
        if (!orderTenor) {
          textMsg += "Tenor  is required<br/>";
        }
        if (!orderInstallment) {
          textMsg += "Angsuran  is required<br/>";
        }
      }

      if (textMsg !== "") {
        throw new Error(textMsg);
      } else {
        return true;
      }
    } catch (error: any) {
      Modal.error({
        title: "Validation Error",
        content: <span dangerouslySetInnerHTML={{ __html: error.message }} />,
      });
      return false;
    }
  }

  onSubmit = async () => {
    const validate = this.validateData();
    if (!validate) {
      return false;
    }

    await this.promisedSetState({
      submitting: true,
    });

    const input: any = {
      dealer_code: this.state.dealerCode,
      data_tax: {
        tax_processing: this.state.taxProcess,
        tax_active: this.state.taxProcess === true ? this.state.taxActive : "",
        tax_percentage_value: this.state.taxProcess === true ? Number(this.state.taxPercetage) : 0,
        tax_url: this.state.taxProcess === true ? this.state.taxUrl : "",
        tax_invoice_number: this.state.taxProcess === true ? this.state.taxInvoiceNumber : "",
        tax_invoice_date: this.state.taxProcess === true ? this.state.taxInvoiceDate : "",
        npwp_publisher_number: this.state.taxProcess === true ? this.state.taxNpwpNumber : "",
        npwp_publisher_name: this.state.taxProcess === true ? this.state.taxNpwpName : "",
        npwp_publisher_address: this.state.taxProcess === true ? this.state.taxNpwpAddress : "",
        receiver_npwp: this.state.taxProcess === true ? this.state.taxReceiverNumber : "",
        receiver_name: this.state.taxProcess === true ? this.state.taxReceiverName : "",
        receiver_address: this.state.taxProcess === true ? this.state.taxReceiverAddress : "",
        total_dpp_non: this.state.taxProcess === true ? Number(this.state.totalDppNon) : 0,
        total_ppn: this.state.taxProcess === true ? Number(this.state.totalPpn) : 0,
        total_pph22: this.state.taxProcess === true ? Number(this.state.totalPph22) : 0,
      },
      data_deposit: this.state.depositData,
      data_unit: [
        {
          order_source: "OTODIS",
          detail_order_source: "APP.OTODIS.COM",

          brand_name: this.state.chosenStock?.vehicle_brand_name,

          customer_type: this.state.customerType ? "BUSINESS_ENTITY" : "INDIVIDUAL",
          customer_business_entity: this.state.customerBusinessEntity,
          customer_name: this.state.customerName,
          customer_phone: this.state.customerPhone,
          customer_doc_name: this.state.customerDocName,
          customer_identity_number: this.state.customerId,
          province_code: this.state.customerProvinceCode,
          province_name: this.state.customerProvinceName,
          city_code: this.state.customerCityCode,
          city_name: this.state.customerCityName,
          district_code: this.state.customerDistrictCode,
          district_name: this.state.customerDistrictName,
          sub_district_code: this.state.customerSubdistrictCode,
          sub_district_name: this.state.customerSubdistrictName,
          address: this.state.customerAddress,
          postcode: this.state.customerPostalCode,

          stock_unit_code: this.state.chosenStock?.stock_unit_code,
          vehicle_engine_number: this.state.chosenStock?.vehicle_engine_number,
          vehicle_variant_code: this.state.chosenStock?.vehicle_variant_code,
          vehicle_color_code: this.state.chosenStock?.vehicle_color_code,
          vehicle_color_name: this.state.chosenStock?.vehicle_color_name,
          vehicle_year: this.state.chosenStock?.vehicle_year,

          marketing_code: this.state?.marketingCode ? this.state.marketingCode : "NO_DATA",
          marketing_name: this.state?.marketingName ? this.state.marketingName : "NO_DATA",
          amh_order_number: this.state.amhOrderNumber,

          incentive_out: this.state.incentiveOut,
          transfer_of_title_null: !this.state.bbn,
          transfer_of_title_cost_estimation: this.state.transferOfTitleCostEstimation,
          notice_cost: this.state.noticeCost,
          process_cost: this.state.processCost,

          vehicle_sales_price: this.state.vehicleSalesPrice,
          order_down_payment: this.state.orderDownPayment,
          order_discount: this.state.orderDiscount,
          order_payment_method: this.state.paymentMethod ? "CREDIT" : "CASH",
          order_create_date: moment(this.state.orderDate).format("YYYY-MM-DD"),

          input_leasing_po: this.state.inputLeasingPo,
          leasing_code: this.state.leasingCode,
          leasing_name: this.state.leasingName,
          leasing_doc_number: this.state.leasingDocNumber,
          leasing_repayment: this.state.leasingRepayment,
          leasing_subsidies: this.state.leasingSubsidies,
          order_tenor: this.state.orderTenor,
          order_installment: this.state.orderInstallment,
          leasing_image_po: this.state.orderImagePo,

          ddms_id_order: this.state.ddmsIdOrder,
          ddms_invoice_number: this.state.ddmsInvoiceNumber,
          ddms_receiver_name: this.state.ddmsReceiverName,

          transfer_title_status: this.state.bbn === true ? "UPLOADED" : "GENERATED",
          service_bureau_code: this.state.serviceBureauCode,
          bbn_invoice_number: this.state.BbnInvoiceNumber,
          document_license_plate: this.state.DocumentLicensePlate,
          document_bpkb: this.state.DocumentBpkb,
          document_stnk: this.state.DocumentStnk,
          document_notice: this.state.DocumentNotice,

          delivery_number: this.state.deliveryNumber,
          delivery_date: this.state.deliveryDate,
          driver_code: this.state.driverCode,
          driver_name: this.state.driverName,
          delivery_license_plate: this.state.deliveryLicensePlate,
          handover_date: this.state.handoverDate,
          receiver_nik: this.state.receiverNik,
          receiver_name: this.state.receiverName,
          receiver_phone: this.state.receiverPhone,
          receiver_signature_url: this.state.receiverSignature,
          receiver_signature_thumb_url: this.state.receiverSignatureThumb,
          handover_proof_url: this.state.handoverProof,
          handover_proof_thumb_url: this.state.handoverProofThumb,
          deposit_data: this.state.depositData,
        },
      ],
    };

    try {
      orderService.setToken(this.token);
      await orderService.insertMultiOrder(input).then((resp) => {
        Modal.success({
          title: "Proses Sukses",
          width: 800,
          content: (
            <div>
              <p>Berhasil, {resp?.data?.data_success?.length} Order yang tersimpan :</p>
              <ul>
                {resp.data.data_success.map((r: any, index: number) => (
                  <li key={index}>{r.order_code}</li>
                ))}
              </ul>
              <p>Data Gagal Tersimpan, {resp?.data?.data_failed?.length} :</p>
              <ul>
                {resp.data.data_failed.map((r: any, index: number) => (
                  <li key={index}>
                    {r.order_code} - {r.vehicle_engine_number}
                  </li>
                ))}
              </ul>
            </div>
          ),
        });

        this.setState(this.initState);

        // setTimeout(function () {
        //   window.location.reload();
        // }, 12000);
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e.message,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  async componentDidMount() {
    await this.fetchDealerData();
  }

  fetchDealerData = async () => {
    try {
      await dealerApiService.getDealer({ dealerCode: this.state.dealerCode }).then(async (response) => {
        const detailDealer = response?.data?.data[0];
        let cityGroup = detailDealer.city_group;

        await this.promisedSetState({
          cityGroup: cityGroup,
          companyCode: detailDealer.company_code,
        });
      });
    } catch (e) {
      console.log(e);
    }
  };

  fetchCopanVariantData = async () => {
    await this.promisedSetState({
      submitting: true,
    });
    try {
      await catalogAreaServices
        .getCatalogVariant({
          areaCode: this.state.cityGroup,
          variantCode: this.state.chosenStock?.vehicle_variant_code,
          companyCode: this.state.companyCode,
        })
        .then(async (dataVariantHome) => {
          this.setState({
            vehicleSalesPrice: dataVariantHome?.data?.meta?.Price,
            vehicleInvoicePrice: dataVariantHome?.data?.meta?.Price,
            submitting: false,
          });
        });
    } catch (e) {
      console.log(e);
    }
  };

  beforeUpload = (file: any) => {
    if (!this.state.customerId) {
      Modal.error({
        title: "Proses Gagal",
        content: "Mohon lengkapi data Order Code",
      });

      this.setState({
        showUploadList: false,
      });
      return false;
    }

    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      Modal.error({
        title: "update Failed",
        content: "mohon upload file dengan tipe image ",
      });
      this.setState({
        showUploadList: false,
      });
    }
    return isImage;
  };

  handleSignatureUpload = (data: any) => {
    if (data?.file?.status === "done") {
      const newImgLocation = data?.file?.response?.data?.url_document;
      const newImgLocationThumb = data?.file?.response?.data?.thumbnail_url;
      this.setState({
        submitting: false,
        receiverSignature: newImgLocation,
        receiverSignatureThumb: newImgLocationThumb,
        showUploadList: true,
      });
    }
    if (data?.file?.status === "uploading") {
      this.setState({
        submitting: true,
      });
    }
    if (data?.file?.status === "removed") {
      this.setState({
        submitting: false,
        receiverSignature: "",
        receiverSignatureThumb: "",
      });
    }
  };

  handleDeliveryProofUpload = (data: any) => {
    if (data?.file?.status === "done") {
      const newImgLocation = data?.file?.response?.data?.url_document;
      const newImgLocationThumb = data?.file?.response?.data?.thumbnail_url;
      this.setState({
        submitting: false,
        handoverProof: newImgLocation,
        handoverProofThumb: newImgLocationThumb,
        showUploadList: true,
      });
    }
    if (data?.file?.status === "uploading") {
      this.setState({
        submitting: true,
      });
    }
    if (data?.file?.status === "removed") {
      this.setState({
        submitting: false,
        handoverProof: "",
        handoverProofThumb: "",
      });
    }
  };

  onSearchBusiness = async (value: any) => {
    try {
      if (this.state.customerBusinessEntity && value !== "") {
        await organizationApiService
          .getBusinessEntities({
            tipe: this.state.customerBusinessEntity,
            npwp: value,
          })
          .then(async (getBusiness) => {
            const dataBussiness = getBusiness?.data?.data;
            if (dataBussiness?.length < 1) {
              Modal.error({
                title: "Error Server",
                content: "Data Not Found",
              });
            }
            await this.promisedSetState({
              customerId: value,
              customerName: dataBussiness[0].Name,
              customerDocName: dataBussiness[0].Name,
              customerPhone: dataBussiness[0].phone_number,
              customerProvinceCode: dataBussiness[0].address.province_code,
              customerProvinceName: dataBussiness[0].address.province_name,
              customerCityCode: dataBussiness[0].address.city_code,
              customerCityName: dataBussiness[0].address.city_name,
              customerDistrictCode: dataBussiness[0].address.district_code,
              customerDistrictName: dataBussiness[0].address.district_name,
              customerSubdistrictCode: dataBussiness[0].address.sub_district_code,
              customerSubdistrictName: dataBussiness[0].address.sub_district_name,
              customerPostalCode: dataBussiness[0].address.zip_code,
              customerAddress: dataBussiness[0].address.full_address,
            });
          });
        // console.log(getBusiness);
      } else {
        Modal.error({
          title: "Error Validation",
          content: "Jenis Badan Usaha & NPWP required",
        });
      }
    } catch (error: any) {
      Modal.error({
        title: "Error Server",
        content: error,
      });
    }
  };

  onGetTax = async (value: any) => {
    try {
      if (this.state.taxUrl && value !== "") {
        this.setState({ submitting: true });
        await taxOtodisService
          .bridgingGetTaxData({
            tax_url: this.state.taxUrl,
          })
          .then(async (taxResult) => {
            if (taxResult.data.success === true) {
              const dataTax = taxResult.data.data;

              await this.promisedSetState({
                taxInvoiceNumber: dataTax.tax_invoice_number,
                taxInvoiceDate: dataTax.tax_invoice_date,
                taxNpwpNumber: dataTax.npwp_publisher_number,
                taxNpwpName: dataTax.npwp_publisher_name,
                taxNpwpAddress: dataTax.npwp_publisher_address,
                taxReceiverNumber: dataTax.receiver_npwp,
                taxReceiverName: dataTax.receiver_name,
                taxReceiverAddress: dataTax.receiver_address,
                totalDppNon: Number(dataTax.total_dpp_non),
                totalPpn: Number(dataTax.total_ppn),
                submitting: false,
              });
            }
          });
      } else {
        Modal.error({
          title: "Error Validation",
          content: "URL PAJAK required",
        });
      }
    } catch (error: any) {
      console.log("error", error);
      this.setState({ submitting: false });

      Modal.error({
        title: "Error Server",
        content: error,
      });
    }
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Order`} breadcrumbMenu={`Buat Order`} defaultSelectedKeys={["m-create-order"]} defaultOpenKeys={["sm-order"]}>
          {this.state.formSearchStock && (
            <Tabs defaultActiveKey="1">
              <TabPane tab="Berdasar Kode Stock" key="1">
                <SearchStockByStockUnit onFetchStockChosen={this.onStockChosen} dealerCode={this.state.dealerCode} />
              </TabPane>
              <TabPane tab="Berdasar Nomor Mesin" key="2">
                <SearchStockByEngineNumber onFetchStockChosen={this.onStockChosen} dealerCode={this.state.dealerCode} />
              </TabPane>
              <TabPane tab="Berdasar Variant Stock" key="3">
                <SearchStockByVariant />
              </TabPane>
            </Tabs>
          )}

          <div style={this.state.chosenStock?.stock_unit_code ? {} : { display: "none" }}>
            <Form layout={"vertical"}>
              <Row justify="end">
                <Col xs={24} xl={2}>
                  <Row>Organisasi : {this.state.companyCode}</Row>
                </Col>
              </Row>
              <Row>
                <Col xs={24} xl={12} className={`pad-10`}>
                  <Row>
                    <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                      <Form.Item>
                        <i className={`text-small-grey-nopadding`}>Tanggal Order</i>
                        <DatePicker defaultValue={moment(this.state.orderDate, "YYYY-MM-DD")} onChange={(event) => this.onOrderDateChange(event)} format={"YYYY-MM-DD"} style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                    <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                      <Form.Item>
                        <i className={`text-small-grey-nopadding`}>Area</i>
                        <Input value={this.state.cityGroup} disabled={true} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col xs={24} xl={12} className={`pad-10`}>
                  <div id="data-konsumen">
                    <Divider orientation="left" plain>
                      <span className={`divider-data-konsumen`}>Data Konsumen</span>
                    </Divider>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <Switch checkedChildren="Badan Usaha" unCheckedChildren="Perorangan" checked={this.state.customerType} onChange={this.onCustomerTypeChange} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item style={this.state.customerType ? {} : { display: "none" }}>
                          <i className={`text-small-grey-nopadding`}>Jenis Badan Usaha</i>
                          <Select
                            placeholder="Pilih Jenis Badan Usaha"
                            optionFilterProp="children"
                            onChange={(value) => this.onStringFieldChange("customerBusinessEntity", value)}
                            value={this.state.customerBusinessEntity}
                          >
                            <Select.Option key={`PT`} value={`PT`}>{`PT`}</Select.Option>
                            <Select.Option key={`CV`} value={`CV`}>{`CV`}</Select.Option>
                            <Select.Option key={`FOUNDATION`} value={`FOUNDATION`}>{`FOUNDATION`}</Select.Option>
                            <Select.Option key={`BANK`} value={`BANK`}>{`BANK`}</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item style={this.state.customerType ? {} : { display: "none" }}>
                          <i className={`text-small-grey-nopadding`}>NPWP</i>
                          <Input.Search placeholder="Cari data berdasarkan NPWP" onSearch={this.onSearchBusiness} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            Nama Konsumen <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input
                            value={this.state.customerName}
                            onChange={(event) => this.onStringFieldChange("customerName", event.target.value)}
                            placeholder="Nama Konsumen"
                            disabled={this.state.disableField}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item style={this.state.customerType ? { display: "none" } : {}}>
                          <i className={`text-small-grey-nopadding`}>
                            ID Konsumen <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.customerId} onChange={(event) => this.onStringFieldChange("customerId", event.target.value)} placeholder="Nomor KTP Konsumen" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Nama Dokumen</i>
                          <Input value={this.state.customerDocName} onChange={(event) => this.onStringFieldChange("customerDocName", event.target.value)} placeholder="Nama Konsumen pada Dokumen" />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            Nomor Telepon Konsumen <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.customerPhone} onChange={(event) => this.onStringFieldChange("customerPhone", event.target.value)} placeholder="Nomor Telpon Konsumen" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Provinsi</i>
                          <AreaProvinceSelect
                            onAreaProvinceChangeProps={this.onAreaProvinceChange}
                            country={"idn"}
                            provinceCode={this.state.customerProvinceCode}
                            provinceName={this.state.customerProvinceName}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Kota</i>
                          <AreaCitySelect onAreaCityChangeProps={this.onAreaCityChange} provinceCode={this.state.customerProvinceCode} cityName={this.state.customerCityName} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Kecamatan</i>
                          <AreaDistrictSelect onAreaDistrictChangeProps={this.onAreaDistrictChange} cityCode={this.state.customerCityCode} districtName={this.state.customerDistrictName} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            Kelurahan <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <AreaSubdistrictSelect
                            onAreaSubdistrictChangeProps={this.onAreaSubdistrictChange}
                            districtCode={this.state.customerDistrictCode}
                            subdistrictName={this.state.customerSubdistrictName}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Kode Pos</i>
                          <Input value={this.state.customerPostalCode} onChange={(event) => this.onStringFieldChange("customerPostalCode", event.target.value)} placeholder="Kode Pos" />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            Alamat <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input.TextArea
                            value={this.state.customerAddress}
                            onChange={(event) => this.onStringFieldChange("customerAddress", event.target.value)}
                            placeholder="Alamat Konsumen"
                            autoSize={{ minRows: 2 }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>

                  <div id="data-marketing">
                    <Divider orientation="left" plain>
                      <span className={`divider-data-marketing`}>Data Marketing</span>
                    </Divider>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Kode Marketing</i>
                          <Input value={this.state.marketingName} onChange={(event) => this.onStringFieldChange("marketingName", event.target.value)} placeholder="Kode Marketing" />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Nama Marketing</i>
                          <Input value={this.state.marketingCode} onChange={(event) => this.onStringFieldChange("marketingCode", event.target.value)} placeholder="Nama Marketing" />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>AMH Order Number</i>
                          <Input
                            value={this.state.amhOrderNumber}
                            onChange={(event) => this.onStringFieldChange("amhOrderNumber", event.target.value)}
                            placeholder="Hiraukan jika Order bukan dari AMH"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>

                  <div id="data-delivery">
                    <Divider orientation="left" plain>
                      <span className={`divider-data-delivery`}>Data Delivery</span>
                    </Divider>

                    <Row>
                      <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Status Delivery</i>
                          <br />
                          <Switch checkedChildren="Sudah Delivery & BAST" unCheckedChildren="Belum Delivery" checked={this.state.orderDelivery} onChange={this.onOrderDelivery} />
                        </Form.Item>
                      </Col>
                    </Row>

                    <div style={this.state.orderDelivery ? {} : { display: "none" }}>
                      <Row>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <i className={`text-small-grey-nopadding`}>
                              No Pengiriman <span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <Input type="text" value={this.state.deliveryNumber} placeholder="No Pengiriman" onChange={(event) => this.onStringFieldChange("deliveryNumber", event.target.value)} />
                          </Form.Item>
                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <i className={`text-small-grey-nopadding`}>
                              Tanggal Pengiriman <span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <DatePicker
                              value={moment(this.state.deliveryDate, "YYYY-MM-DD")}
                              format={"YYYY-MM-DD"}
                              style={{ width: "100%" }}
                              onChange={(date, dateString) => this.onStringFieldChange("deliveryDate", dateString)}
                              disabledDate={(current) => current && current < moment().startOf("day")}
                            />
                          </Form.Item>
                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <i className={`text-small-grey-nopadding`}>
                              Sopir <span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <OtodisDeliveryDriverSelect onDriverChangeProps={this.onDriverChange} dealerCode={this.state.dealerCode} value={this.state.driverCode} />
                          </Form.Item>
                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <i className={`text-small-grey-nopadding`}>
                              No Polisi Kendaraan <span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <OtodisDeliveryVehicleSelect onAssetChangeProps={this.ondeliveryLicensePlateChange} dealerCode={this.state.dealerCode} value={this.state.deliveryLicensePlate} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Divider orientation="left" plain>
                        <span className={`divider-data-handover`}>Data Handover</span>
                      </Divider>
                      <Row>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <i className={`text-small-grey-nopadding`}>
                              Tanggal Handover <span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <DatePicker
                              value={moment(this.state.handoverDate, "YYYY-MM-DD")}
                              format={"YYYY-MM-DD"}
                              style={{ width: "100%" }}
                              onChange={(date, dateString) => this.onStringFieldChange("handoverDate", dateString)}
                              disabledDate={(current) => current && current < moment().startOf("day")}
                            />
                          </Form.Item>
                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <i className={`text-small-grey-nopadding`}>
                              NIK Penerima <span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <Input type="text" value={this.state.receiverNik} placeholder="NIK Penerima" onChange={(event) => this.onStringFieldChange("receiverNik", event.target.value)} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <i className={`text-small-grey-nopadding`}>
                              Nama Penerima <span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <Input type="text" value={this.state.receiverName} placeholder="Nama Penerima" onChange={(event) => this.onStringFieldChange("receiverName", event.target.value)} />
                          </Form.Item>
                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                          <Form.Item style={{ paddingRight: 10 }}>
                            <i className={`text-small-grey-nopadding`}>
                              Telepon Penerima <span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <Input type="number" value={this.state.receiverPhone} placeholder="Telepon Penerima" onChange={(event) => this.onStringFieldChange("receiverPhone", event.target.value)} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10, paddingBottom: 10 }}>
                          <Upload.Dragger
                            name="image"
                            accept="image/*"
                            method="POST"
                            action={baseUrlCdnUpload + "/upload-document/document-data"}
                            listType="picture"
                            maxCount={1}
                            data={{
                              document_name: `signature-${this.state.customerId.replace(/#/g, "-")}`,
                              document_type: "signature",
                              source: "app.otodis.com",
                            }}
                            onChange={this.handleSignatureUpload}
                            beforeUpload={this.beforeUpload}
                            style={{ width: "100%", height: 200 }}
                            showUploadList={false}
                          >
                            {this.state.receiverSignature ? (
                              <img src={this.state.receiverSignature} alt="Tanda Tangan" style={{ height: 200 }} />
                            ) : (
                              <div>
                                <p className="ant-upload-drag-icon">
                                  <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Klik atau Drag untuk mengupload File</p>
                                <p className="ant-upload-hint">Upload tanda tangan penerima</p>
                              </div>
                            )}
                          </Upload.Dragger>
                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10, paddingBottom: 10 }}>
                          <Upload.Dragger
                            name="image"
                            accept="image/*"
                            method="POST"
                            action={baseUrlCdnUpload + "/upload-document/document-data"}
                            listType="picture"
                            maxCount={1}
                            data={{
                              document_name: `receipt_of_goods-${this.state.customerId.replace(/#/g, "-")}`,
                              document_type: "receipt_of_goods",
                              source: "app.otodis.com",
                            }}
                            onChange={this.handleDeliveryProofUpload}
                            beforeUpload={this.beforeUpload}
                            style={{ width: "100%", height: 200 }}
                            showUploadList={false}
                          >
                            {this.state.handoverProof ? (
                              <img src={this.state.handoverProof} alt="Bukti Serah Terima" style={{ height: 200 }} />
                            ) : (
                              <div>
                                <p className="ant-upload-drag-icon">
                                  <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Klik atau Drag untuk mengupload File</p>
                                <p className="ant-upload-hint">Upload bukti serah terima kendaraan</p>
                              </div>
                            )}
                          </Upload.Dragger>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>

                <Col xs={24} xl={12} className={`pad-10`}>
                  <div id="data-stock">
                    <Divider orientation="left" plain>
                      <span className={`divider-data-stock`}>Data Stock</span>
                    </Divider>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            Kode Stock <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.chosenStock?.stock_unit_code} disabled={true} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Kondisi Stock</i>
                          <Input value={this.state.chosenStock?.stock_condition} disabled={true} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Kode Variant Stock</i>
                          <Input value={this.state.chosenStock?.vehicle_variant_code} disabled={true} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Variant Stock</i>
                          <Input value={this.state.chosenStock?.vehicle_variant_name} disabled={true} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Kode Warna</i>
                          <Input value={this.state.chosenStock?.vehicle_color_code} disabled={true} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Nama Warna</i>
                          <Input value={this.state.chosenStock?.vehicle_color_name} disabled={true} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Nomor Mesin</i>
                          <Input value={this.state.chosenStock?.vehicle_engine_number} disabled={true} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Nomor Rangka</i>
                          <Input value={this.state.chosenStock?.vehicle_chassis_number} disabled={true} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Tahun Kendaraan</i>
                          <Input value={this.state.chosenStock?.vehicle_year} disabled={true} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>

                  <div id="data-harga">
                    <Divider orientation="left" plain>
                      <span className={`divider-data-harga`}>Data Harga Kendaraan</span>
                    </Divider>
                    <Row>
                      <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <i className={`text-small-grey-nopadding`}>Metode Beli</i>
                        <br />
                        <Switch
                          checkedChildren="Pembayaran Kredit"
                          unCheckedChildren="Pembayaran Tunai"
                          checked={this.state.paymentMethod}
                          // onChange={this.onPaymentMethodChange}
                          onChange={(value) => this.onStringFieldChange("paymentMethod", value)}
                        />
                        <br />
                        <br />
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Harga Jual (OTR)</i>
                          <CurrencyInput
                            className={"ant-input"}
                            allowDecimals={false}
                            decimalsLimit={2}
                            groupSeparator={"."}
                            decimalSeparator={","}
                            prefix={"Rp. "}
                            value={this.state.vehicleSalesPrice}
                            onValueChange={(value) => this.onStringFieldChange("vehicleSalesPrice", value ? parseFloat(value) : 0)}
                            disabled={!this.state.paymentMethod ? this.state.disableField : false}
                            // loading={this.state.submitting}
                          />
                        </Form.Item>
                      </Col>
                      {/* <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item label="&nbsp;">
                          <Button onClick={this.fetchCopanVariantData} loading={this.state.submitting}>
                            Gunakan Harga Copan
                          </Button>
                        </Form.Item>
                      </Col> */}
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            Harga Invoice <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <CurrencyInput
                            className={"ant-input"}
                            allowDecimals={false}
                            decimalsLimit={2}
                            groupSeparator={"."}
                            decimalSeparator={","}
                            prefix={"Rp. "}
                            value={this.state.vehicleInvoicePrice}
                            onValueChange={(value) => this.onStringFieldChange("vehicleInvoicePrice", value ? parseFloat(value) : 0)}
                            disabled
                            // loading={this.state.submitting}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Uang Muka (DP)</i>
                          <CurrencyInput
                            className={"ant-input"}
                            allowDecimals={false}
                            decimalsLimit={2}
                            groupSeparator={"."}
                            decimalSeparator={","}
                            prefix={"Rp. "}
                            value={this.state.orderDownPayment}
                            onValueChange={(value) => this.onStringFieldChange("orderDownPayment", value ? parseFloat(value) : 0)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Diskon</i>
                          <CurrencyInput
                            className={"ant-input"}
                            allowDecimals={false}
                            decimalsLimit={2}
                            groupSeparator={"."}
                            decimalSeparator={","}
                            prefix={"Rp. "}
                            value={this.state.orderDiscount}
                            onValueChange={(value) => this.onStringFieldChange("orderDiscount", value ? parseFloat(value) : 0)}
                          />
                        </Form.Item>
                      </Col>

                      <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <DepositComponent onDepositUpdate={this.onDepositUpdate} totalDeposit={this.state.vehicleDeposit} depositData={this.state.depositData} />
                      </Col>
                    </Row>

                    <div style={this.state.inputLeasingPo ? {} : { display: "none" }}>
                      <Divider orientation="left" plain>
                        <Checkbox checked={this.state.inputLeasingPo}>
                          {" "}
                          <span className={`divider-stock-purchase`}> Data Leasing PO </span>{" "}
                        </Checkbox>
                      </Divider>

                      <Row>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                          <Form.Item>
                            <i className={`text-small-grey-nopadding`}>
                              Leasing<span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <LeasingSelect onLeasingChangeProps={this.onLeasingChange} />
                          </Form.Item>
                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                          <Form.Item>
                            <i className={`text-small-grey-nopadding`}>Nomor Dokumen Leasing</i>
                            <Input value={this.state.leasingDocNumber} onChange={(event) => this.onStringFieldChange("leasingDocNumber", event.target.value)} placeholder="Nomor Dokumen Leasing" />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                          <Form.Item>
                            <i className={`text-small-grey-nopadding`}>Piutang Leasing (PK)</i>
                            <CurrencyInput
                              className={"ant-input"}
                              allowDecimals={false}
                              decimalsLimit={2}
                              groupSeparator={"."}
                              decimalSeparator={","}
                              prefix={"Rp. "}
                              value={this.state.leasingRepayment}
                              disabled={true}
                            />
                          </Form.Item>
                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                          <Form.Item>
                            <i className={`text-small-grey-nopadding`}>Subsidi Leasing (PP)</i>
                            <CurrencyInput
                              className={"ant-input"}
                              allowDecimals={false}
                              decimalsLimit={2}
                              groupSeparator={"."}
                              decimalSeparator={","}
                              prefix={"Rp. "}
                              value={this.state.leasingSubsidies}
                              onValueChange={(value) => this.onStringFieldChange("leasingSubsidies", value ? parseFloat(value) : 0)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                          <Form.Item>
                            <i className={`text-small-grey-nopadding`}>
                              Jumlah Tenor <span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <CurrencyInput
                              className={"ant-input"}
                              allowDecimals={false}
                              value={this.state.orderTenor}
                              onValueChange={(value) => this.onStringFieldChange("orderTenor", value ? parseFloat(value) : 0)}
                            />
                          </Form.Item>
                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                          <Form.Item>
                            <i className={`text-small-grey-nopadding`}>
                              Nilai Angsuran<span style={{ color: "red" }}>*</span>{" "}
                            </i>
                            <CurrencyInput
                              className={"ant-input"}
                              allowDecimals={false}
                              decimalsLimit={2}
                              groupSeparator={"."}
                              decimalSeparator={","}
                              prefix={"Rp. "}
                              value={this.state.orderInstallment}
                              onValueChange={(value) => this.onStringFieldChange("orderInstallment", value ? parseFloat(value) : 0)}
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <div id="databbn">
                    <br />
                    <Divider orientation="left" plain>
                      <span className={`divider-other-data`}>Data BBN</span>
                    </Divider>

                    <Row>
                      <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>BBN</i>
                          <br />
                          <Switch
                            checkedChildren="Dengan BBN"
                            unCheckedChildren="Tanpa BBN"
                            checked={this.state.bbn}
                            // onChange={this.onBbnChange}
                            onChange={(value) => this.onStringFieldChange("bbn", value)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={this.state.bbn ? { paddingRight: 10 } : { display: "none" }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            Biro Jasa <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <ServicebureauSelect onSupplierChangeProps={this.onSupplierChange} dealerCode={this.state.dealerCode} value={this.state.serviceBureauCode} />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            Estimasi Biaya BBN <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <CurrencyInput
                            className={"ant-input"}
                            allowDecimals={false}
                            decimalsLimit={2}
                            groupSeparator={"."}
                            decimalSeparator={","}
                            prefix={"Rp. "}
                            value={this.state.transferOfTitleCostEstimation}
                            onValueChange={(value) => this.onStringFieldChange("transferOfTitleCostEstimation", value ? parseFloat(value) : 0)}
                            disabled={true}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            Biaya Notice <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <CurrencyInput
                            className={"ant-input"}
                            allowDecimals={false}
                            decimalsLimit={2}
                            groupSeparator={"."}
                            decimalSeparator={","}
                            prefix={"Rp. "}
                            value={this.state.noticeCost}
                            onValueChange={(value) => this.onStringFieldChange("noticeCost", value ? parseFloat(value) : 0)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            Biaya Proses <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <CurrencyInput
                            className={"ant-input"}
                            allowDecimals={false}
                            decimalsLimit={2}
                            groupSeparator={"."}
                            decimalSeparator={","}
                            prefix={"Rp. "}
                            value={this.state.processCost}
                            onValueChange={(value) => this.onStringFieldChange("processCost", value ? parseFloat(value) : 0)}
                          />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={this.state.bbn ? { paddingRight: 10 } : { display: "none" }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            No Tagihan BBN <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.BbnInvoiceNumber} onChange={(event) => this.onStringFieldChange("BbnInvoiceNumber", event.target.value)} placeholder="No Tagihan BBN" />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={this.state.bbn ? { paddingRight: 10 } : { display: "none" }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            No Polisi <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.DocumentLicensePlate} onChange={(event) => this.onStringFieldChange("DocumentLicensePlate", event.target.value)} placeholder="No Polisi" />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={this.state.bbn ? { paddingRight: 10 } : { display: "none" }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            No BPKB <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.DocumentBpkb} onChange={(event) => this.onStringFieldChange("DocumentBpkb", event.target.value)} placeholder="No BPKB" />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={this.state.bbn ? { paddingRight: 10 } : { display: "none" }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            No STNK <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.DocumentStnk} onChange={(event) => this.onStringFieldChange("DocumentStnk", event.target.value)} placeholder="No STNK" />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={this.state.bbn ? { paddingRight: 10 } : { display: "none" }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>
                            No Notice <span style={{ color: "red" }}>*</span>{" "}
                          </i>
                          <Input value={this.state.DocumentNotice} onChange={(event) => this.onStringFieldChange("DocumentNotice", event.target.value)} placeholder="No Notice" />
                        </Form.Item>
                      </Col>
                      {/* </Row>

                    <Row> */}
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>DDMS ID Order</i>
                          <Input value={this.state.ddmsIdOrder} onChange={(event) => this.onStringFieldChange("ddmsIdOrder", event.target.value)} placeholder="DDMS ID Order" />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>DDMS Nama Konsumen</i>
                          <Input value={this.state.ddmsReceiverName} onChange={(event) => this.onStringFieldChange("ddmsReceiverName", event.target.value)} placeholder="DDMS Nama Konsumen" />
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>DDMS Invoice STNK</i>
                          <Input value={this.state.ddmsInvoiceNumber} onChange={(event) => this.onStringFieldChange("ddmsInvoiceNumber", event.target.value)} placeholder="DDMS Invoice STNK" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </Col>

                <Col xs={24} xl={24} className={`pad-10`}>
                  <div id="data-dokumen-pajak">
                    <br />
                    <Divider orientation="left" plain>
                      <span className={`divider-other-data`}>Data Pajak</span>
                    </Divider>

                    <Row>
                      <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                        <Form.Item>
                          <i className={`text-small-grey-nopadding`}>Process Pajak</i>
                          <br />
                          <Switch
                            checkedChildren="ACTIVE"
                            unCheckedChildren="NONACTIVE"
                            checked={this.state.taxProcess}
                            // onChange={this.onBbnChange}
                            onChange={(value) => this.onStringFieldChange("taxProcess", value)}
                          />
                        </Form.Item>
                      </Col>
                      {this.state.taxProcess && (
                        <React.Fragment>
                          <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>PPN</i>
                              <br />
                              <Switch
                                checkedChildren="ON"
                                unCheckedChildren="OFF"
                                checked={this.state.taxActive}
                                // onChange={this.onBbnChange}
                                onChange={(value) => this.onStringFieldChange("taxActive", value)}
                              />
                            </Form.Item>
                          </Col>
                          <Col xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                URL Pajak <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              {/* <Input value={this.state.taxUrl} onChange={(event) => this.onStringFieldChange("taxUrl", event.target.value)} placeholder="URL Pajak" /> */}
                              <Input.Search
                                placeholder="Get data Pajak"
                                onSearch={this.onGetTax}
                                value={this.state.taxUrl}
                                onChange={(event) => this.onStringFieldChange("taxUrl", event.target.value)}
                                loading={this.state.submitting}
                              />
                            </Form.Item>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                No Faktur Pajak <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Input
                                value={this.state.taxInvoiceNumber}
                                onChange={(event) => this.onStringFieldChange("taxInvoiceNumber", event.target.value)}
                                placeholder="No Faktur Pajak"
                                disabled
                              />
                            </Form.Item>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                Tgl Faktur Pajak <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Input value={this.state.taxInvoiceDate} onChange={(event) => this.onStringFieldChange("taxInvoiceDate", event.target.value)} placeholder="Tgl Faktur Pajak" disabled />
                            </Form.Item>
                          </Col>
                          <Col xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                No. NPWP Dealer <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Input value={this.state.taxNpwpNumber} onChange={(event) => this.onStringFieldChange("taxNpwpNumber", event.target.value)} placeholder="No. NPWP Dealer" disabled />
                            </Form.Item>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                Nama NPWP Dealer <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Input value={this.state.taxNpwpName} onChange={(event) => this.onStringFieldChange("taxNpwpName", event.target.value)} placeholder="Nama NPWP Dealer" disabled />
                            </Form.Item>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                Alamat NPWP Dealer <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Input value={this.state.taxNpwpAddress} onChange={(event) => this.onStringFieldChange("taxNpwpAddress", event.target.value)} placeholder="Alamat NPWP Dealer" disabled />
                            </Form.Item>
                          </Col>
                          <Col xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                No. NPWP Konsumen <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Input
                                value={this.state.taxReceiverNumber}
                                onChange={(event) => this.onStringFieldChange("taxReceiverNumber", event.target.value)}
                                placeholder="No. NPWP Konsumen"
                                disabled
                              />
                            </Form.Item>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                Nama NPWP Konsumen <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Input
                                value={this.state.taxReceiverName}
                                onChange={(event) => this.onStringFieldChange("taxReceiverName", event.target.value)}
                                placeholder="Nama NPWP Konsumen"
                                disabled
                              />
                            </Form.Item>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                Alamat NPWP Konsumen <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Input
                                value={this.state.taxReceiverAddress}
                                onChange={(event) => this.onStringFieldChange("taxReceiverAddress", event.target.value)}
                                placeholder="Alamat NPWP Konsumen"
                                disabled
                              />
                            </Form.Item>
                          </Col>
                          <Col xl={{ span: 6 }} lg={{ span: 6 }} md={{ span: 8 }} sm={{ span: 12 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                Persentasi Pajak <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <Input type="number" value={this.state.taxPercetage} onChange={(event) => this.onStringFieldChange("taxPercetage", event.target.value)} />
                            </Form.Item>

                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                Jumlah DDP <span style={{ color: "red" }}>*</span> Estimasi : {this.state.estTotalDppNon.toLocaleString()}
                              </i>
                              <CurrencyInput
                                className={"ant-input"}
                                allowDecimals={false}
                                decimalsLimit={2}
                                groupSeparator={"."}
                                decimalSeparator={","}
                                prefix={"Rp. "}
                                value={this.state.totalDppNon}
                                onValueChange={(value) => this.onStringFieldChange("totalDppNon", value ? parseFloat(value) : 0)}
                                disabled={true}
                              />
                            </Form.Item>
                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                Jumlah PPN <span style={{ color: "red" }}>*</span> Estimasi : {this.state.estTotalPpn.toLocaleString()}
                              </i>
                              <CurrencyInput
                                className={"ant-input"}
                                allowDecimals={false}
                                decimalsLimit={2}
                                groupSeparator={"."}
                                decimalSeparator={","}
                                prefix={"Rp. "}
                                value={this.state.totalPpn}
                                onValueChange={(value) => this.onStringFieldChange("totalPpn", value ? parseFloat(value) : 0)}
                                disabled={true}
                              />
                            </Form.Item>

                            <Form.Item>
                              <i className={`text-small-grey-nopadding`}>
                                Nilai PPH22 <span style={{ color: "red" }}>*</span>{" "}
                              </i>
                              <CurrencyInput
                                className={"ant-input"}
                                allowDecimals={false}
                                decimalsLimit={2}
                                groupSeparator={"."}
                                decimalSeparator={","}
                                prefix={"Rp. "}
                                value={this.state.totalPph22}
                                onValueChange={(value) => this.onStringFieldChange("totalPph22", value ? parseFloat(value) : 0)}
                                disabled={this.state.taxActive ? true : false}
                              />
                            </Form.Item>
                          </Col>
                        </React.Fragment>
                      )}
                    </Row>
                  </div>
                </Col>
              </Row>

              <Col span={24} className={`pad-10`}>
                <Form.Item>
                  <br />
                  <Button type={"primary"} icon={<SaveOutlined />} onClick={this.onSubmit} loading={this.state.submitting}>
                    Buat Order
                  </Button>
                </Form.Item>
              </Col>
            </Form>
          </div>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(CreateOrder), 7);
